<template>
  <div class="home-table-responsive">
    <ul class="home-table-responsive__list">
      <li
        v-for="(item, index) in itemsToDisplay"
        :key="index"
        class="home-table-responsive__list-item"
      >
        <div v-if="isLoading" class="home-table-responsive__list-item-loading">
          <loading-placeholder :lines="3" />
        </div>
        <template v-else>
          <router-link :to="getDetailRouterLink(item)">
            <home-table-list-item-responsive :item="item" :from-all="fromAll" :custom-fields="customFields" />
          </router-link>
        </template>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import { RouteLocationRaw } from 'vue-router'

/* Mixins */

/* Components */
import HomeTableListItemResponsive from './home-table-list-item-responsive.vue'
import { IHomeTableItem } from '@/types/data-objects/items'
import { HomeTableProps } from '@/components/listing/home-table/home-table.constants'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default defineComponent({
  name: 'HomeTableResponsive',

  components: {
    HomeTableListItemResponsive,
  },

  props: {
    ...HomeTableProps,
  },

  data() {
    return {
      itemsLoading: new Array(2).fill({}),
    }
  },

  computed: {
    itemsToDisplay(): IHomeTableItem[] {
      return this.isLoading ? this.itemsLoading : this.tableData
    },

    isMailbox(): boolean {
      return this.type === EEntities.MAILBOXES
    },

    isProject(): boolean {
      return this.type === EEntities.PROJECTS
    },
  },

  methods: {
    /**
     * Get a Route object to be used in router-link component
     * according to the object
     */
    getDetailRouterLink(row: IHomeTableItem): RouteLocationRaw {
      if (this.isMailbox) {
        return RouteAssistant.getConversationRoute(
          this.$route.params.accountId,
          row.parent.id,
          row.id.toString(),
          row.parent.name,
          row.refNumber,
          row.title,
          null,
          this.fromAll,
          this.fromEntityHome,
        )
      } else {
        return RouteAssistant.getTaskRoute(
          this.$route.params.accountId,
          row.parent.id,
          row.id.toString(),
          this.$permissions,
          row.parent.name,
          row.refNumber,
          row.title,
          null,
          this.fromAll,
          this.fromEntityHome,
        )
      }
    },
  },
})
</script>

<style lang="scss">
.home-table-responsive {
  max-width: 100vw;
  background-color: var(--color-general-white);
  border-top: 1px solid $silver-two;
  box-shadow: 0 3px 0 0 rgba(96, 76, 63, 0.16);

  &__list {
    padding: 0;
    margin: 0;
    list-style: none;
    background-color: $silver-two;
  }

  &__list-item {
    margin-bottom: 2px;
    padding: 8px $detail-gutter-pad-sm 10px;
    background-color: var(--color-general-white);
    border-bottom: 1px solid $light-blue-grey-two;

    &:last-child {
      border: none;
    }

    &-loading {
      margin-top: 10px;
    }

    a {
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
